import {gitVersion} from './../git-version';
import {environment} from './environments/environment';

export const datadogConfigRUM: any = {
  applicationId: '57025801-d6b8-4b87-a0df-703ce1e33c46',
  clientToken: 'pub6a18c923823d65ad970cf80c50397bc5',
  site: 'datadoghq.eu',
  service: 'myvodafone-business',
  sampleRate: (environment.production) ? 100 : 100,
  premiumSampleRate: (environment.production) ? 0 : 100,
  trackInteractions: true,
  defaultPrivacyLevel: 'mask-user-input',
  env: environment.name,
  version: `${gitVersion.branch}@${gitVersion.commit}`,
  trackFrustrations: true,
  excludedActivityUrls: [
    // Exclude any URL containing tags.tiqcdn.com
    (url) => url.startsWith('https://tags.tiqcdn.com')
  ],
  beforeSend(event) {
    if ( event.error ) {
      const isNonErrorException =
        event.error.stack.startsWith('SyntaxError: Unexpected token');

      if (isNonErrorException) {
        return false;
      }
    }
  }
};


export const datadogConfigLogger: any = {
  applicationId: '57025801-d6b8-4b87-a0df-703ce1e33c46',
  clientToken: 'pub6a18c923823d65ad970cf80c50397bc5',
  site: 'datadoghq.eu',
  service: 'myvodafone-business',
  env: environment.name,
  version: `${gitVersion.branch}@${gitVersion.commit}`,
  forwardErrorsToLogs: true,
  sampleRate: 100,
};
